import {IMentionData} from "react-mentions";
import TextUtils from "./TextUtils";

export default class MentionUtils {

	/**
	 * Return plain text with "span" element where mention exist
	 * Example:
	 * given: "some text @[John Doe](1234-4354=323) xyx" returns: "some text <span class="mention">@John Doe</span> xyz"
	 * To display this text use "dangerouslySetInnerHTML" attribute if withoutHtml flag not set
	 * @param {string} input
	 * @param withoutHtml if true return text without wrapped mention element
	 * @returns {string}
	 */
	static getPlainText(input: string, withoutHtml?: boolean) {
		let result;
		let text = input;
		const regexp = this.getRegexp();

		while ((result = regexp.exec(text))) {
			text = text.replace(result[0], withoutHtml ?
				this.displayTransform(result[1]) :
				`<span class="mention">${this.displayTransform(result[1])}</span>`);
		}
		return TextUtils.createTextLinks(text)
	}

	static displayTransform(display: string) {
		return `@${display}`
	}

	/**
	 * Return regexp to find element with structure "@[some text](some uid)"
	 * @returns {RegExp}
	 */
	static getRegexp() {
		return new RegExp("@\\[(.+?)\\]\\((.+?)\\)");
	}

	/**
	 * Return all mentions data from given input
	 * Example:
	 * given "some text @[John Doe](1234-4354=323) xyx @[Joe Doe](1234-4321) zyx" returns: [{id: "1234-4354=323", display: "John Doe"}, {id:"1234-4321", display: "Joe Doe"}]
	 * @param {string} input
	 * @returns {"react-mentions".IMentionData[]}
	 */
	static getMentions(input: string): IMentionData[] {
		let result;
		let text = input;
		const regexp = this.getRegexp();
		const toReturn = [];

		while ((result = regexp.exec(text))) {
			toReturn.push({id: result[2], display: result[1]});
			text = text.replace(result[0], "");
		}
		return toReturn
	}
}

